import { Box, Container, Typography, Grid } from '@mui/material';
import { motion } from 'framer-motion';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import ContactForm from '../../components/ContactForm';
import CTAButton from '../../components/CTAButton';
import SEO from '../../components/SEO';

const LaundryFromHomes = () => {
  return (
    <>
      <SEO 
        title="Home Laundry Services Kampala | Pickup & Delivery Laundry Uganda"
        description="Convenient laundry pickup & delivery service in Kampala. Professional washing, drying, ironing & folding. Premium garment care. Same-day service available. Call 0752 058 190"
        keywords="laundry service Kampala, laundry pickup delivery Uganda, dry cleaning Kampala, ironing service Uganda, garment care Kampala, wash and fold service"
        url="https://blossomcleaningservices.com/services/laundry-from-homes"
      />
      <Header />

      <Box sx={{ position: 'relative', py: 12, backgroundImage: 'url(https://images.unsplash.com/photo-1582735689369-4fe89db7114c?w=1920&q=80)', backgroundSize: 'cover', backgroundPosition: 'center', '&::before': { content: '""', position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(34, 51, 95, 0.75)' } }}>
        <Container sx={{ position: 'relative', zIndex: 1 }}>
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
            <Typography variant="h1" sx={{ mb: 3, color: 'white', fontSize: { xs: '2.5rem', md: '3.5rem' } }}>
              Laundry Collection & Delivery
            </Typography>
            <Typography variant="h5" sx={{ maxWidth: 800, color: 'rgba(255,255,255,0.95)', mb: 4 }}>
              Professional laundry service from the comfort of your home
            </Typography>
            <CTAButton to="/contact">Schedule Pickup</CTAButton>
          </motion.div>
        </Container>
      </Box>

      <Box sx={{ py: 8 }}>
        <Container>
          <Typography variant="h3" sx={{ mb: 4, fontWeight: 600 }}>
            Convenient Home Laundry Service
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
            Skip the laundromat with our convenient pickup and delivery service. We collect your laundry from your home, wash, dry, iron, and fold it professionally, then deliver it back to you fresh and clean.
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
            Our service includes washing, drying, ironing, and folding of all garments. We use high-quality detergents and fabric care products, with special attention to delicate items and specific care instructions.
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
            Same-day and next-day options available. Whether it's regular laundry or special care items like curtains and bedding, we handle it all with professional care.
          </Typography>
        </Container>
      </Box>

      <Box sx={{ py: 8, backgroundColor: 'background.paper' }}>
        <Container maxWidth="md">
          <ContactForm title="Book Laundry Service" showServiceSelect={false} />
        </Container>
      </Box>

      <Footer />
    </>
  );
};

export default LaundryFromHomes;
